import { DeepPartial } from 'react-hook-form';
import { FormValues, Period } from '@graphql/index';

export const applicationFormInitialState: DeepPartial<FormValues> = {
  Identification: {
    applicant: {
      identification: {
        type: undefined,
      },
    },
    isSameAddress: true,
  },
  IncomeVerification: {
    applicant: {
      income: {
        primary: {
          documents: [],
          bankStatementComplete: false,
        },
      },
    },
  },
  HouseholdDetails: {
    applicant: {
      maritalStatus: '',
      expense: {
        mortgage: {
          amount: 0,
          period: Period.Monthly,
          isNotApplicable: undefined,
        },
        rent: {
          amount: 0,
          period: Period.Monthly,
          isNotApplicable: undefined,
        },
        investmentProperties: {
          amount: 0,
          period: Period.Monthly,
          isNotApplicable: undefined,
        },
        otherLoans: {
          amount: 0,
          period: Period.Monthly,
          isNotApplicable: undefined,
        },
        creditCards: {
          limit: 0,
          isNotApplicable: undefined,
        },
        household: {
          period: Period.Monthly,
        },
      },
      income: {
        partnerIncome: {
          amount: 0,
          period: Period.Monthly,
          isNotApplicable: false,
        },
      },
    },
  },

  // SFA
  BusinessDetails: {
    isSame: true,
  },

  IncomeReview: {
    applicant: {
      income: {
        primary: {
          amount: 0,
          period: Period.Monthly,
        },
        isAdditionalIncome: false,
      },
    },
  },
};
